import script from "./CompanyCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyCreateView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyCreateView.vue?vue&type=style&index=0&id=1409a7f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1409a7f8"]])

export default __exports__